module.exports = "/assets/data/889ce0c9a9d55bf740e833b31e624812-SW1A.data.json";